import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    --black: #090806;
    --black-soft: #12100d;
    --dark: #18130f;

    --cream: #fff8ec;
    --cream-soft: #f4eadc;
    --cream-card: #fffdf8;

    --gold: #dda12f;
    --gold-light: #f4c55d;
    --gold-dark: #a97012;

    --red: #b92b25;
    --green: #2f6b3f;

    --text: #1f1711;
    --muted: #7b6b5c;
    --white: #ffffff;

    --radius: 24px;
    --shadow: 0 24px 70px rgba(0, 0, 0, 0.18);
    --shadow-soft: 0 16px 45px rgba(0, 0, 0, 0.10);

    --container: 1280px;
    --nav-height: 96px;
  }

  * {
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
    overflow-x: hidden;
    overflow-x: clip;
  }

  body {
    margin: 0;
    font-family: Inter, Arial, Helvetica, sans-serif;
    background: var(--cream);
    color: var(--text);
    overflow-x: hidden;
    overflow-x: clip;
  }

  #root {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  main {
    flex: 1;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  button,
  input,
  select,
  textarea {
    font-family: inherit;
  }

  button {
    border: 0;
  }

  img {
    max-width: 100%;
    display: block;
  }

  section {
    scroll-margin-top: calc(var(--nav-height) + 24px);
    overflow-x: hidden;
    overflow-x: clip;
  }

  ::selection {
    background: var(--gold);
    color: #fff;
  }

  @media (max-width: 760px) {
    :root {
      --nav-height: 86px;
    }
  }
`;

export default GlobalStyles;
